/* Cânon Nissi — INSCRIÇÕES (alunos e professoras)
   ===========================================================================
   Os dados da inscrição são anexados à PRÓPRIA LINHA DO CARRINHO, como line
   item properties. Viajam com a encomenda e ficam visíveis no carrinho, no
   checkout, na encomenda no admin e nos talões.

   Não há e-mail enviado pelo tema. Consequências:
   - sem hCaptcha e sem páginas de desafio pelo caminho
   - sem navegações extra antes do pagamento
   - nada se perde: os dados estão na encomenda, não numa mensagem que pode
     falhar
   - só existem inscrições de encomendas que chegaram a ser feitas

   O e-mail para info@canonnissi.pt faz-se no admin, com o Shopify Flow:
   gatilho "Order paid" -> enviar e-mail interno com os dados da encomenda.

   Dois modais, conforme a tag do produto:
   - "Aluno"      -> nome + idade por filho; o nível sai da idade, lendo a
                     faixa etária do título da variante (nada hard-coded)
   - "Professora" -> nome + data de nascimento; não há nível a recomendar

   Markup: cn-matricula-modal.liquid, cn-professora-modal.liquid,
           cn-inscricao-estilos.liquid
*/
(function () {
  'use strict';

  if (window.__CN_INSCRICOES_BOOTED) return;
  window.__CN_INSCRICOES_BOOTED = true;

  // ---------------------------------------------------------------- utils --
  function q(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function esc(s) {
    return String(s == null ? '' : s);
  }
  function fmtEur(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
  }
  function fmtData(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(esc(iso));
    return m ? m[3] + '/' + m[2] + '/' + m[1] : esc(iso);
  }

  var PROFILE_KEY = 'cn_matricula_perfil_v1';

  // -------------------------------------------------- número de matrícula --
  // Formato: ALU-26-K7X2Q9 (alunos) / PRF-26-M4B8TN (professores).
  // O alfabeto não tem O/0 nem I/1, para o número poder ser ditado ao telefone
  // ou copiado à mão sem confusões.
  // É um código de referência gerado no browser, não um sequencial: ver a nota
  // no fim deste ficheiro sobre o que isso implica.
  var ALFABETO = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

  function sorteia(n) {
    var buf = null;
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        buf = new Uint32Array(n);
        window.crypto.getRandomValues(buf);
      }
    } catch (e) {}
    var out = '';
    for (var i = 0; i < n; i++) {
      var v = buf ? buf[i] : Math.floor(Math.random() * 4294967296);
      out += ALFABETO.charAt(v % ALFABETO.length);
    }
    return out;
  }

  function novoNumero(prefixo) {
    return prefixo + '-' + String(new Date().getFullYear()).slice(-2) + '-' + sorteia(6);
  }

  // =========================================================================
  // Peças partilhadas pelos dois modais
  // =========================================================================
  var modalAtivo = null;

  function addToCart(itens) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error((json && json.description) || 'cart-error');
        return json;
      });
    });
  }

  function refreshCartBubble() {
    return fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var host = document.getElementById('cart-icon-bubble');
        var html = data && data['cart-icon-bubble'];
        if (!host || !html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var sec = parsed.querySelector('.shopify-section') || parsed.body;
        if (sec) host.innerHTML = sec.innerHTML;
      })
      .catch(function () {});
  }

  function bloco(titulo) {
    var div = document.createElement('div');
    div.className = 'cnm-sum-block';
    var h = document.createElement('p');
    h.className = 'cnm-sum-title';
    h.textContent = titulo;
    div.appendChild(h);
    return div;
  }

  // Lista o carrinho completo com os dados de inscrição de cada linha, para o
  // utilizador confirmar tudo antes de pagar.
  function renderCartList(summary) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var itens = (cart && cart.items) || [];
        var antigo = q('.cnm-cart-block', summary);
        if (antigo && antigo.parentNode) antigo.parentNode.removeChild(antigo);
        if (!itens.length) return;

        var b = bloco(
          'No seu carrinho (' + cart.item_count + (cart.item_count === 1 ? ' artigo' : ' artigos') + ')'
        );
        b.className += ' cnm-cart-block';

        var ul = document.createElement('ul');
        itens.forEach(function (it) {
          var li = document.createElement('li');
          var nome = it.product_title || it.title || 'Produto';
          var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          var preco = it.final_line_price != null ? '  ' + fmtEur(it.final_line_price) : '';
          li.appendChild(document.createTextNode(nome + (v ? ' — ' + v : '') + ' ×' + (it.quantity || 1) + preco));

          var props = it.properties;
          if (props && typeof props === 'object') {
            var chaves = Object.keys(props).filter(function (k) {
              return k.charAt(0) !== '_' && props[k];
            });
            if (chaves.length) {
              var sub = document.createElement('ul');
              sub.className = 'cnm-props';
              chaves.forEach(function (k) {
                var sli = document.createElement('li');
                var strong = document.createElement('strong');
                strong.textContent = k + ': ';
                sli.appendChild(strong);
                sli.appendChild(document.createTextNode(esc(props[k])));
                sub.appendChild(sli);
              });
              li.appendChild(sub);
            }
          }
          ul.appendChild(li);
        });
        b.appendChild(ul);

        if (cart.total_price != null) {
          var total = document.createElement('p');
          total.className = 'cnm-sum-total';
          total.textContent = 'Total: ' + fmtEur(cart.total_price);
          b.appendChild(total);
        }
        summary.appendChild(b);
      })
      .catch(function () {});
  }

  // Chrome comum: abrir, fechar, focus trap.
  function criarChrome(cfg) {
    var overlay = cfg.overlay;

    function estaAberto() {
      return overlay.classList.contains('cnm-open');
    }
    function showAlert(msg) {
      if (!cfg.alertBox) return;
      cfg.alertBox.textContent = msg;
      cfg.alertBox.hidden = false;
      try {
        cfg.alertBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } catch (e) {}
    }
    function clearAlert() {
      if (!cfg.alertBox) return;
      cfg.alertBox.hidden = true;
      cfg.alertBox.textContent = '';
    }

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
      ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function focusaveis() {
      return qa(FOCUSABLE, overlay).filter(function (el) {
        if (el.hidden) return false;
        if (el.closest && el.closest('[hidden]')) return false;
        return true;
      });
    }
    function focar() {
      var itens = focusaveis();
      if (itens.length) {
        try {
          itens[0].focus();
        } catch (e) {}
      }
    }

    var lastTrigger = null;

    function abrir(trigger) {
      try {
        if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      } catch (e) {}
      if (trigger) lastTrigger = trigger;
      clearAlert();
      if (cfg.stepSuccess) cfg.stepSuccess.hidden = true;
      if (cfg.stepForm) cfg.stepForm.hidden = false;
      if (cfg.titleEl) cfg.titleEl.textContent = cfg.tituloInicial;
      if (cfg.aoAbrir) cfg.aoAbrir();

      overlay.classList.add('cnm-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cnm-modal-open');
      document.documentElement.classList.add('cnm-modal-open');

      setTimeout(function () {
        if (cfg.stepForm && !cfg.stepForm.hidden) focar();
      }, 60);
    }

    function fechar() {
      if (cfg.ocupado && cfg.ocupado()) return;
      overlay.classList.remove('cnm-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cnm-modal-open');
      document.documentElement.classList.remove('cnm-modal-open');
      if (lastTrigger && document.contains(lastTrigger)) {
        try {
          lastTrigger.focus();
        } catch (e) {}
      }
    }

    [cfg.btnClose, cfg.btnCancel, cfg.btnKeep].forEach(function (b) {
      if (b) b.addEventListener('click', fechar);
    });
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) fechar();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && estaAberto()) fechar();
    });
    overlay.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Tab') return;
      var itens = focusaveis();
      if (!itens.length) return;
      var first = itens[0];
      var last = itens[itens.length - 1];
      if (ev.shiftKey && document.activeElement === first) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && document.activeElement === last) {
        ev.preventDefault();
        first.focus();
      }
    });
    document.addEventListener('focusin', function (ev) {
      if (!estaAberto()) return;
      if (overlay.contains(ev.target)) return;
      focar();
    });

    return {
      abrir: abrir,
      fechar: fechar,
      focar: focar,
      estaAberto: estaAberto,
      showAlert: showAlert,
      clearAlert: clearAlert
    };
  }

  // Interceção dos botões de compra — registada uma só vez.
  var BUY_SELECTORS = [
    '#preorder-button',
    '#botao-comprar-agora-custom',
    'button[name="add"]',
    '.product-form__submit',
    '.custom-add-to-cart-button',
    'button.add-to-cart',
    'button[data-add-to-cart]',
    '#AddToCart',
    '#add-to-cart',
    '.button-encomendar',
    'button[data-encomendar]',
    'button.cn-preorder',
    '.shopify-payment-button__button'
  ];
  function ehBotaoCompra(el) {
    if (!el || !el.matches) return false;
    for (var i = 0; i < BUY_SELECTORS.length; i++) {
      try {
        if (el.matches(BUY_SELECTORS[i])) return true;
      } catch (e) {}
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (ev) {
      if (!modalAtivo) return;
      if (modalAtivo.overlay.contains(ev.target)) return;
      var el = ev.target;
      for (var i = 0; i < 5 && el; i++, el = el.parentElement) {
        if (!ehBotaoCompra(el)) continue;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        if (modalAtivo.chrome.estaAberto()) modalAtivo.chrome.focar();
        else modalAtivo.chrome.abrir(el);
        return;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (ev) {
      if (!modalAtivo) return;
      var f = ev.target;
      if (!f || modalAtivo.overlay.contains(f)) return;
      var action = (f.getAttribute('action') || '').toLowerCase();
      var ehAdd = action.indexOf('/cart/add') !== -1 || !!f.querySelector('input[name="id"]');
      if (!ehAdd) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ev.stopPropagation();
      if (!modalAtivo.chrome.estaAberto()) modalAtivo.chrome.abrir(null);
    },
    true
  );

  // Adefe e responsável repetem-se entre inscrições da mesma visita.
  function saveProfile(dados) {
    try {
      sessionStorage.setItem(PROFILE_KEY, JSON.stringify(dados));
    } catch (e) {}
  }
  function readProfile() {
    try {
      return JSON.parse(sessionStorage.getItem(PROFILE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  // =========================================================================
  // MODAL DE ALUNO
  // =========================================================================
  function initAluno(DATA) {
    var overlay = q('#cn-matricula-overlay');
    var template = q('#cnm-aluno-template');
    if (!overlay || !template) return;

    function parseAgeRange(title) {
      var t = esc(title).toLowerCase().replace(/\s+/g, ' ');
      var m;
      // Alternativas mais longas primeiro: "aos" não pode ser comido pelo "a".
      m = t.match(/(\d{1,2})\s*(?:-|–|—|\/|aos|at[ée]|ao|a)\s*(\d{1,2})\s*anos?/);
      if (m) {
        var a = parseInt(m[1], 10);
        var b = parseInt(m[2], 10);
        return { min: Math.min(a, b), max: Math.max(a, b) };
      }
      m = t.match(/(?:a partir de|acima de|mais de|\+\s*de)\s*(\d{1,2})\s*anos?/);
      if (m) return { min: parseInt(m[1], 10), max: 99 };
      m = t.match(/(\d{1,2})\s*\+\s*anos?/);
      if (m) return { min: parseInt(m[1], 10), max: 99 };
      m = t.match(/at[ée]\s*(\d{1,2})\s*anos?/);
      if (m) return { min: 0, max: parseInt(m[1], 10) };
      m = t.match(/(\d{1,2})\s*anos?/);
      if (m) return { min: parseInt(m[1], 10), max: parseInt(m[1], 10) };
      return null;
    }

    var VARIANTS = (DATA.variants || []).map(function (v) {
      return { id: String(v.id), title: esc(v.title), available: v.available !== false, age: parseAgeRange(v.title) };
    });
    var AGE_VARIANTS = VARIANTS.filter(function (v) {
      return v.age !== null;
    });

    function recommendForAge(age) {
      if (!AGE_VARIANTS.length) return null;
      var exact = AGE_VARIANTS.filter(function (v) {
        return age >= v.age.min && age <= v.age.max;
      });
      if (exact.length) return { variant: exact[0], exact: true };
      var best = null;
      var bestDistance = Infinity;
      AGE_VARIANTS.forEach(function (v) {
        var d = age < v.age.min ? v.age.min - age : age - v.age.max;
        if (d < bestDistance) {
          bestDistance = d;
          best = v;
        }
      });
      return best ? { variant: best, exact: false } : null;
    }
    function findVariantById(id) {
      var alvo = String(id);
      for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].id === alvo) return VARIANTS[i];
      return null;
    }

    var stepForm = q('#cnm-step-form', overlay);
    var stepSuccess = q('#cnm-step-success', overlay);
    var form = q('#cnm-form', overlay);
    var alunosBox = q('#cnm-alunos', overlay);
    var btnSubmit = q('#cnm-submit', overlay);
    var guardando = false;

    function val(sel) {
      var el = q(sel, overlay);
      return el ? String(el.value || '').trim() : '';
    }
    function linhas() {
      return qa('.cnm-aluno', alunosBox);
    }
    function renumerar() {
      var todas = linhas();
      todas.forEach(function (row, i) {
        var num = q('.cnm-aluno-num', row);
        if (num) num.textContent = todas.length === 1 ? 'Aluno' : 'Aluno ' + (i + 1);
        var rm = q('.cnm-remove', row);
        if (rm) rm.hidden = todas.length < 2;
      });
    }
    function preencherSelect(sel) {
      sel.innerHTML = '';
      VARIANTS.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title + (v.available ? '' : ' — esgotado');
        opt.disabled = !v.available;
        sel.appendChild(opt);
      });
    }

    function renderLinha(row) {
      var idade = parseInt(q('.cnm-idade', row).value, 10);
      var reco = q('.cnm-reco', row);
      var nome = q('.cnm-reco-name', row);
      var nota = q('.cnm-reco-note', row);
      var manual = row.dataset.manual === '1';
      var sel = q('.cnm-select', row);
      var wrapManual = q('.cnm-manual', row);
      var toggle = q('.cnm-toggle-manual', row);

      if (!AGE_VARIANTS.length) {
        reco.hidden = false;
        nome.textContent = 'Selecione o nível pretendido';
        nota.hidden = false;
        nota.textContent = 'Este produto não tem faixas etárias definidas nas variantes.';
        if (toggle) toggle.hidden = true;
        row.dataset.manual = '1';
        if (wrapManual) wrapManual.hidden = false;
        return;
      }
      if (!isFinite(idade) || idade < 1) {
        if (!manual) reco.hidden = true;
        return;
      }

      reco.hidden = false;
      var r = recommendForAge(idade);

      if (manual) {
        var escolhida = findVariantById(sel && sel.value);
        nome.textContent = escolhida ? escolhida.title : '—';
        nota.hidden = false;
        nota.textContent = r ? 'Sugestão automática para ' + idade + ' anos: ' + r.variant.title + '.' : '';
        return;
      }
      if (!r) {
        nome.textContent = '—';
        nota.hidden = true;
        return;
      }
      nome.textContent = r.variant.title;
      if (!r.variant.available) {
        nota.hidden = false;
        nota.textContent = 'Este nível está esgotado de momento. Escolha outro nível abaixo.';
      } else if (r.exact) {
        nota.hidden = true;
        nota.textContent = '';
      } else {
        nota.hidden = false;
        nota.textContent =
          'A idade indicada (' + idade + ' anos) está fora das faixas disponíveis. Sugerimos o nível mais próximo — pode alterar abaixo.';
      }
      if (sel) sel.value = r.variant.id;
    }

    function variantDaLinha(row) {
      if (row.dataset.manual === '1') {
        var sel = q('.cnm-select', row);
        return sel ? findVariantById(sel.value) : null;
      }
      var idade = parseInt(q('.cnm-idade', row).value, 10);
      if (!isFinite(idade)) return null;
      var r = recommendForAge(idade);
      return r ? r.variant : null;
    }

    function adicionarLinha() {
      var frag = template.content.cloneNode(true);
      var row = frag.querySelector('.cnm-aluno');
      var sel = q('.cnm-select', row);
      if (sel) preencherSelect(sel);

      var idade = q('.cnm-idade', row);
      idade.addEventListener('input', function () {
        renderLinha(row);
      });
      idade.addEventListener('change', function () {
        renderLinha(row);
      });

      var toggle = q('.cnm-toggle-manual', row);
      toggle.addEventListener('click', function (ev) {
        ev.preventDefault();
        var agora = row.dataset.manual === '1' ? '0' : '1';
        row.dataset.manual = agora;
        q('.cnm-manual', row).hidden = agora !== '1';
        toggle.textContent = agora === '1' ? 'Voltar à recomendação automática' : 'Não é este o nível? Escolher outro';
        renderLinha(row);
      });
      if (sel) {
        sel.addEventListener('change', function () {
          row.dataset.manual = '1';
          q('.cnm-manual', row).hidden = false;
          toggle.textContent = 'Voltar à recomendação automática';
          renderLinha(row);
        });
      }
      q('.cnm-remove', row).addEventListener('click', function () {
        if (linhas().length < 2) return;
        row.parentNode.removeChild(row);
        renumerar();
      });

      alunosBox.appendChild(frag);
      renumerar();
      return alunosBox.lastElementChild;
    }

    var chrome = criarChrome({
      overlay: overlay,
      stepForm: stepForm,
      stepSuccess: stepSuccess,
      titleEl: q('#cnm-title', overlay),
      alertBox: q('#cnm-alert', overlay),
      tituloInicial: 'Matrícula do aluno',
      btnClose: q('#cnm-close', overlay),
      btnCancel: q('#cnm-cancel', overlay),
      btnKeep: q('#cnm-keep-shopping', overlay),
      ocupado: function () {
        return guardando;
      },
      aoAbrir: function () {
        alunosBox.innerHTML = '';
        adicionarLinha();
        if (btnSubmit) {
          btnSubmit.disabled = false;
          btnSubmit.textContent = 'GUARDAR MATRÍCULA';
        }
        // Nome do responsável e Adefe repetem-se; nome e idade do aluno NUNCA
        // são repostos — o produto seguinte é muitas vezes para outro filho, e
        // uma idade herdada inscreve a criança no nível errado.
        var nota = q('#cnm-prefill-note', overlay);
        if (nota) {
          nota.hidden = true;
          nota.textContent = '';
        }
        var p = readProfile();
        if (!p) return;
        var r = q('#cnm-responsavel', overlay);
        var a = q('#cnm-adefe', overlay);
        var mexeu = false;
        if (r && !r.value && p.responsavel) {
          r.value = p.responsavel;
          mexeu = true;
        }
        if (a && !a.value && p.adefe) {
          a.value = p.adefe;
          mexeu = true;
        }
        if (mexeu && nota) {
          nota.textContent = 'Dados do responsável preenchidos a partir da inscrição anterior. Pode alterá-los.';
          nota.hidden = false;
        }
      }
    });

    var btnAdd = q('#cnm-add-aluno', overlay);
    if (btnAdd) {
      btnAdd.addEventListener('click', function () {
        var nova = adicionarLinha();
        var campo = q('.cnm-nome', nova);
        if (campo) {
          try {
            campo.focus();
          } catch (e) {}
        }
      });
    }

    function mostrarConfirmacao(novas) {
      var titleEl = q('#cnm-title', overlay);
      if (titleEl) titleEl.textContent = 'Matrícula guardada';
      if (stepForm) stepForm.hidden = true;
      if (stepSuccess) stepSuccess.hidden = false;
      var texto = q('#cnm-success-text', overlay);
      if (texto) {
        texto.textContent =
          novas.length === 1
            ? 'Registámos a matrícula de ' + novas[0].nome + '.'
            : 'Registámos ' + novas.length + ' matrículas.';
      }
      var summary = q('#cnm-summary', overlay);
      if (!summary) return;
      summary.innerHTML = '';
      renderCartList(summary);
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (guardando) return;
        chrome.clearAlert();

        var responsavel = val('#cnm-responsavel');
        var adefe = val('#cnm-adefe');
        if (!responsavel || !adefe) {
          chrome.showAlert('Preencha o nome do responsável e a Adefe.');
          return;
        }

        var rows = linhas();
        var novas = [];
        var itens = [];
        var erro = null;

        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var nome = String(q('.cnm-nome', row).value || '').trim();
          var idade = parseInt(q('.cnm-idade', row).value, 10);
          if (!nome) {
            erro = 'Indique o nome completo do ' + (rows.length > 1 ? 'aluno ' + (i + 1) : 'filho(a)') + '.';
            break;
          }
          if (!isFinite(idade) || idade < 1 || idade > 99) {
            erro = 'Indique uma idade válida para ' + nome + '.';
            break;
          }
          var variant = variantDaLinha(row);
          if (!variant) {
            erro = 'Não foi possível determinar o nível de ' + nome + '. Escolha-o manualmente.';
            break;
          }
          if (!variant.available) {
            erro = 'O nível "' + variant.title + '" está esgotado. Escolha outro nível para ' + nome + '.';
            break;
          }

          // Os dados seguem agarrados à linha do carrinho e, daí, à encomenda.
          // O número vem primeiro para ser a primeira coisa que se lê, tanto no
          // carrinho como no e-mail.
          var props = {
            'Nº de matrícula': novoNumero('ALU'),
            Aluno: nome,
            Idade: idade + ' anos',
            Responsável: responsavel,
            Adefe: adefe
          };
          if (row.dataset.manual === '1') props['Nível escolhido manualmente'] = 'Sim';

          // Uma linha por filho: propriedades diferentes não se agrupam, e é
          // assim que cada criança fica identificada na encomenda.
          itens.push({ id: variant.id, quantity: 1, properties: props });
          novas.push({ nome: nome, idade: idade, nivel: variant.title });
        }

        if (erro) {
          chrome.showAlert(erro);
          return;
        }

        guardando = true;
        btnSubmit.disabled = true;
        btnSubmit.textContent = 'A GUARDAR...';

        addToCart(itens)
          .then(function () {
            saveProfile({ responsavel: responsavel, adefe: adefe });
            return refreshCartBubble().then(function () {
              mostrarConfirmacao(novas);
            });
          })
          .catch(function (err) {
            chrome.showAlert(
              'Não foi possível adicionar o material ao carrinho: ' + String((err && err.message) || '') + '. Tente novamente.'
            );
            btnSubmit.disabled = false;
            btnSubmit.textContent = 'GUARDAR MATRÍCULA';
          })
          .then(function () {
            guardando = false;
          });
      });
    }

    modalAtivo = { overlay: overlay, chrome: chrome };
  }

  // =========================================================================
  // MODAL DE PROFESSORA
  // =========================================================================
  function initProfessora(DATA) {
    var overlay = q('#cn-professora-overlay');
    var template = q('#cnp-pessoa-template');
    if (!overlay || !template) return;

    var VARIANTS = (DATA.variants || []).map(function (v) {
      return { id: String(v.id), title: esc(v.title), available: v.available !== false };
    });
    var VARIANTES_REAIS = VARIANTS.length > 1; // "Default Title" sozinho não é escolha
    var VARIANTE_UNICA = VARIANTS[0] || null;

    var stepForm = q('#cnp-step-form', overlay);
    var stepSuccess = q('#cnp-step-success', overlay);
    var form = q('#cnp-form', overlay);
    var pessoasBox = q('#cnp-pessoas', overlay);
    var btnSubmit = q('#cnp-submit', overlay);
    var guardando = false;

    function val(sel) {
      var el = q(sel, overlay);
      return el ? String(el.value || '').trim() : '';
    }
    function linhas() {
      return qa('.cnm-aluno', pessoasBox);
    }
    function renumerar() {
      var todas = linhas();
      todas.forEach(function (row, i) {
        var num = q('.cnm-aluno-num', row);
        if (num) num.textContent = todas.length === 1 ? 'Professor(a)' : 'Professor(a) ' + (i + 1);
        var rm = q('.cnm-remove', row);
        if (rm) rm.hidden = todas.length < 2;
      });
    }

    function adicionarLinha() {
      var frag = template.content.cloneNode(true);
      var row = frag.querySelector('.cnm-aluno');

      var campoVar = q('.cnp-variante-campo', row);
      var sel = q('.cnp-select', row);
      if (VARIANTES_REAIS && sel && campoVar) {
        q('.cnp-variante-label', row).textContent = esc(DATA.optionName || 'Opção');
        sel.innerHTML = '';
        VARIANTS.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = v.title + (v.available ? '' : ' — esgotado');
          opt.disabled = !v.available;
          sel.appendChild(opt);
        });
        campoVar.hidden = false;
      }

      var nasc = q('.cnp-nascimento', row);
      if (nasc) {
        try {
          nasc.max = new Date().toISOString().slice(0, 10);
        } catch (e) {}
      }

      q('.cnm-remove', row).addEventListener('click', function () {
        if (linhas().length < 2) return;
        row.parentNode.removeChild(row);
        renumerar();
      });

      pessoasBox.appendChild(frag);
      renumerar();
      return pessoasBox.lastElementChild;
    }

    var chrome = criarChrome({
      overlay: overlay,
      stepForm: stepForm,
      stepSuccess: stepSuccess,
      titleEl: q('#cnp-title', overlay),
      alertBox: q('#cnp-alert', overlay),
      tituloInicial: 'Inscrição do(a) professor(a)',
      btnClose: q('#cnp-close', overlay),
      btnCancel: q('#cnp-cancel', overlay),
      btnKeep: q('#cnp-keep-shopping', overlay),
      ocupado: function () {
        return guardando;
      },
      aoAbrir: function () {
        pessoasBox.innerHTML = '';
        adicionarLinha();
        if (btnSubmit) {
          btnSubmit.disabled = false;
          btnSubmit.textContent = 'GUARDAR INSCRIÇÃO';
        }
        var nota = q('#cnp-prefill-note', overlay);
        if (nota) {
          nota.hidden = true;
          nota.textContent = '';
        }
        var p = readProfile();
        var a = q('#cnp-adefe', overlay);
        if (p && a && !a.value && p.adefe) {
          a.value = p.adefe;
          if (nota) {
            nota.textContent = 'Adefe preenchida a partir da inscrição anterior. Pode alterá-la.';
            nota.hidden = false;
          }
        }
      }
    });

    var btnAdd = q('#cnp-add-pessoa', overlay);
    if (btnAdd) {
      btnAdd.addEventListener('click', function () {
        var nova = adicionarLinha();
        var campo = q('.cnp-nome', nova);
        if (campo) {
          try {
            campo.focus();
          } catch (e) {}
        }
      });
    }

    function mostrarConfirmacao(novas) {
      var titleEl = q('#cnp-title', overlay);
      if (titleEl) titleEl.textContent = 'Inscrição guardada';
      if (stepForm) stepForm.hidden = true;
      if (stepSuccess) stepSuccess.hidden = false;
      var texto = q('#cnp-success-text', overlay);
      if (texto) {
        texto.textContent =
          novas.length === 1
            ? 'Registámos a inscrição de ' + novas[0].nome + '.'
            : 'Registámos ' + novas.length + ' inscrições.';
      }
      var summary = q('#cnp-summary', overlay);
      if (!summary) return;
      summary.innerHTML = '';
      renderCartList(summary);
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (guardando) return;
        chrome.clearAlert();

        var adefe = val('#cnp-adefe');
        if (!adefe) {
          chrome.showAlert('Indique em que Adefe vai lecionar.');
          return;
        }

        var rows = linhas();
        var novas = [];
        var itens = [];
        var erro = null;
        var hoje = new Date();

        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var nome = String(q('.cnp-nome', row).value || '').trim();
          var nascimento = String(q('.cnp-nascimento', row).value || '').trim();
          var ordinal = rows.length > 1 ? 'professor(a) ' + (i + 1) : 'professor(a)';

          if (!nome) {
            erro = 'Indique o nome da ' + ordinal + '.';
            break;
          }
          if (!/^\d{4}-\d{2}-\d{2}$/.test(nascimento)) {
            erro = 'Indique a data de nascimento de ' + nome + '.';
            break;
          }
          var d = new Date(nascimento);
          if (isNaN(d.getTime()) || d > hoje) {
            erro = 'A data de nascimento de ' + nome + ' não pode ser no futuro.';
            break;
          }

          var variant = VARIANTES_REAIS
            ? (function () {
                var sel = q('.cnp-select', row);
                var alvo = sel ? String(sel.value) : '';
                for (var k = 0; k < VARIANTS.length; k++) if (VARIANTS[k].id === alvo) return VARIANTS[k];
                return null;
              })()
            : VARIANTE_UNICA;

          if (!variant) {
            erro = 'Escolha a opção do material para ' + nome + '.';
            break;
          }
          if (!variant.available) {
            erro = 'O material está esgotado de momento.';
            break;
          }

          itens.push({
            id: variant.id,
            quantity: 1,
            properties: {
              'Nº de matrícula': novoNumero('PRF'),
              'Professor(a)': nome,
              'Data de nascimento': fmtData(nascimento),
              'Adefe onde vai lecionar': adefe
            }
          });
          novas.push({ nome: nome, nascimento: nascimento });
        }

        if (erro) {
          chrome.showAlert(erro);
          return;
        }

        guardando = true;
        btnSubmit.disabled = true;
        btnSubmit.textContent = 'A GUARDAR...';

        addToCart(itens)
          .then(function () {
            var p = readProfile() || {};
            p.adefe = adefe;
            saveProfile(p);
            return refreshCartBubble().then(function () {
              mostrarConfirmacao(novas);
            });
          })
          .catch(function (err) {
            chrome.showAlert(
              'Não foi possível adicionar o material ao carrinho: ' + String((err && err.message) || '') + '. Tente novamente.'
            );
            btnSubmit.disabled = false;
            btnSubmit.textContent = 'GUARDAR INSCRIÇÃO';
          })
          .then(function () {
            guardando = false;
          });
      });
    }

    modalAtivo = { overlay: overlay, chrome: chrome };
  }

  /* NOTA sobre o número de matrícula
     ------------------------------------------------------------------------
     É um código de REFERÊNCIA gerado no browser, não um número sequencial de
     um registo central. Implicações:
     - não é 1, 2, 3...: é aleatório, e não diz quantas matrículas existem;
     - não há garantia absoluta de unicidade. São 32^6 (~1000 milhões) de
       combinações por prefixo e por ano, portanto colidir é muito improvável,
       mas não impossível. O número do pedido desempata sempre.
     - um número só existe a partir do momento em que a pessoa guarda a
       inscrição; se remover o artigo e voltar a acrescentar, sai outro.
     Para um registo verdadeiramente sequencial e garantido seria preciso uma
     base de dados — ou seja, uma app, não um tema. */

  // Um produto com as duas tags usa o modal de aluno: é o mais específico.
  if (window.CN_MATRICULA && window.CN_MATRICULA.active) initAluno(window.CN_MATRICULA);
  else if (window.CN_PROFESSORA && window.CN_PROFESSORA.active) initProfessora(window.CN_PROFESSORA);
})();
